import { memo } from 'react';

import Menu from '@material-ui/core/Menu';

import { listItemProps } from '../Navigation.utils';
import { SubNavigationItem } from '../navigationItem/subNavigationItem/SubNavigationItem';
import { useStyles } from './DropdownMenu.styles';
import { DropdownMenuProps } from './DropdownMenu.types';

export const DropdownMenu = memo(
  ({ anchorEl, open, submenuItems, user, handleSubmenuClose, ...props }: DropdownMenuProps) => {
    const styles = useStyles();

    return (
      <Menu
        anchorEl={anchorEl}
        open={open}
        disableAutoFocus={true}
        disableEnforceFocus={true}
        disableRestoreFocus={true}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PopoverClasses={{
          root: styles.popoverRoot,
          paper: styles.popoverPaper,
        }}
        classes={{ list: styles.list }}
        getContentAnchorEl={null}
        onClose={handleSubmenuClose}
        {...props}
      >
        {submenuItems?.map((submenuItem, index) => (
          <SubNavigationItem
            key={submenuItem.name}
            subItemName={submenuItem.name}
            badge={submenuItem.badge}
            listItemProps={listItemProps({
              htmlId: submenuItem.htmlId ?? `menu-option-${index + 1}`,
              menuItem: submenuItem,
              user,
            })}
          />
        ))}
      </Menu>
    );
  },
);
